export default "__VITE_ASSET__RACsD0ds__"